/* Lederwerk: Preise sind brutto hinterlegt – in den Produktkacheln wird netto (20 % MwSt) angezeigt */
(function () {
  var MWST = 1.2;
  var PREIS_SEL = '.lwks-preis-p,.lwst-preis,.lwpu-preis,.lwsu-kp,.lwpr-preis,.lwdiy-card-price,.lwsp-wert,' +
    '[data-lwks-vid] b,[data-lwst-vid] b,[data-lwpu-vid] b';
  var BETRAG = /(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})/g;

  function fmt(cent) {
    var e = Math.floor(cent / 100), c = String(cent % 100);
    if (c.length < 2) c = '0' + c;
    return String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + c;
  }

  function netto(text) {
    return text.replace(BETRAG, function (m, eur, ct) {
      var brutto = parseInt(eur.replace(/\./g, ''), 10) * 100 + parseInt(ct, 10);
      return fmt(Math.round(brutto / MWST));
    });
  }

  function umrechnen(el) {
    if (el.getAttribute('data-lw-netto')) return;
    if (el.textContent.indexOf('€') === -1 && el.textContent.indexOf('EUR') === -1) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      if (n.parentNode && n.parentNode.classList && n.parentNode.classList.contains('lw-zzgl')) continue;
      n.nodeValue = netto(n.nodeValue);
    }
    el.setAttribute('data-lw-netto', '1');
    var istButton = el.tagName === 'B';
    var hatInklSpan = el.parentNode && el.parentNode.querySelector && el.parentNode.querySelector('.lwks-inkl');
    if (!istButton && !hatInklSpan && !el.querySelector('.lw-zzgl')) {
      var s = document.createElement('small');
      s.className = 'lw-zzgl';
      s.style.cssText = 'font-size:.75em;opacity:.75;font-weight:400;';
      s.textContent = ' zzgl. MwSt';
      el.appendChild(s);
    }
  }

  function lauf(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(PREIS_SEL).forEach(umrechnen);
    scope.querySelectorAll('.lwks-inkl').forEach(function (el) {
      if (/inkl/i.test(el.textContent)) el.textContent = 'zzgl. MwSt';
    });
    scope.querySelectorAll('.product__tax').forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), t;
      while ((t = w.nextNode())) t.nodeValue = t.nodeValue.replace(/Inkl\.\s*Steuern\.?/i, '');
    });
  }

  function start() {
    lauf(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches(PREIS_SEL)) umrechnen(n);
          lauf(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
